import { UserManager } from "oidc-react";
import { AsyncState } from "./AsyncState";

export class AuthState extends AsyncState {
    userManager: UserManager | null = null;
    currentUser: any = null;
    isAuthenticated: boolean = false;
}